import module from 'module';
import $ from "jquery";

import templateUrl from './auction-tag-view.template.html';
import './auction-tag-view.style.less';

const calculateAuctionPricePath = `/dashboard/appraisals/auction-price/calculate`;
const retagPath = `/dashboard/stocked-items/retag`;

class AuctionTagViewComponent {
  constructor(http, nav, printService, $timeout, $routeParams, $location, pawnItemCache) {
    this.http = http;
    this.nav = nav;
    this.printService = printService;
    this.$timeout = $timeout;
    this.$routeParams = $routeParams;
    this.$location = $location;
    this.pawnItemCache = pawnItemCache;
    this.isPrintPreviewLoaded = false;
  }

  $onInit() {
    /**
     * Fixes a bug where the page does not load correctly when it is refreshed forcefully and only one selectedIds was passed.
     * When refreshed forcefully, $routeParams treats single-value parameters as a String object. It is only an array where there is more than 1 selectedIds being passed.
     */
    if (this.$routeParams && this.$routeParams.selectedIds) {
      let ids = this.$routeParams.selectedIds;
      if (!Array.isArray(ids)) {
        ids = [ids];
      }
      this.selectedIds = ids.map(Number);
    }

    this.usePawnItemSellingPriceAndCost = this.$routeParams.usePawnItemSellingPriceAndCost ? this.$routeParams.usePawnItemSellingPriceAndCost : false;
    this.selectedBranchId = this.$routeParams.selectedBranchId ? Number(this.$routeParams.selectedBranchId) : null;

    this.$timeout(() => {
      this.http.post(`/print/AUCTION_TAG/json`, {
        pawnItemIds: this.selectedIds,
        usePawnItemSellingPriceAndCost: this.usePawnItemSellingPriceAndCost
      }).success(doc => {
        this.pawnItemCache.evict();
        this.isPrintPreviewLoaded = true;

        return this.printService.printToContainer(doc, {
          autoPrint: false,
          backgroundEnabled: true,
          container: $('.iframe-preview')
        });
      });
    });
  }

  redirectBack() {
    const selectedIds = this.selectedIds;
    const selectedBranchId = this.selectedBranchId;

    // As of the moment, there are only two entry points into this auction tag view: calculate auction price and retagging.
    if (selectedIds && selectedBranchId) {
      this.$location.path(calculateAuctionPricePath).search({
        selectedIds : selectedIds,
        selectedBranchId: selectedBranchId
      });
    }

    // If the branch id is not provided, the previous page must be the retagging page.
    if (selectedIds && !selectedBranchId) {
      this.$location.path(retagPath).search({
        selectedIds: selectedIds
      });
    }
  }

  async print() {
    await this.http.post(`/print/AUCTION_TAG/json`, {
      pawnItemIds: this.selectedIds,
      usePawnItemSellingPriceAndCost: this.usePawnItemSellingPriceAndCost
    }).success(doc => {
      return this.printService.printToContainer(doc, {
        autoPrint: true,
        backgroundEnabled: true,
        container: $('.iframe-invisible')
      });
    });
  }

  $onDestroy() {
    const path = this.$location.path();
    if (this.selectedIds &&
      (![calculateAuctionPricePath, retagPath].includes(path))) {
      this.$location.search({});
    }
  }
}

module.component('auctionTagView', {
  templateUrl: templateUrl,
  controller: AuctionTagViewComponent
});